import React, { useContext, useEffect, useState } from 'react'
import Swiper from 'react-id-swiper'
import styled from 'styled-components'

import { LayoutContext, useUI } from '../../contexts'
import { SiteLink } from '../shared/SiteLink'
import { useCollectionClickedTracking } from '../../hooks/tracking'

const CollectionSwitcher = ({ collections, location }) => {
  const { node_locale, currency } = useContext(LayoutContext)
  const [currentSlug, setCurrentSlug] = useState(
    location?.pathname.split('/')[2],
  )

  const params = {
    spaceBetween: 18,
    slidesPerView: 4.5,
  }

  useEffect(() => {
    setCurrentSlug(location?.pathname.split('/')[2])
  }, [location])

  return (
    <CollectionListContainer>
      <StyledSwiper>
        <Swiper {...params}>
          {collections.links.map(({ title, target: { slug } }) => {
            return (
              <Slide key={title}>
                <CollectionListLink
                  to={slug}
                  selected={currentSlug === slug}
                  onClick={() =>
                    useCollectionClickedTracking({
                      currency: currency?.code,
                      locale: node_locale,
                      name: title,
                      label: title,
                      linkType: 'Link',
                      sectionType: 'Collection Switcher Mobile',
                      destination: `/${node_locale}/${slug}/`,
                    })
                  }
                  state={{ referrer: location.pathname }}
                  aria-label={`Switch to ${title} collection`}
                >
                  {title}
                </CollectionListLink>
              </Slide>
            )
          })}
          <CollectionListLink>&nbsp;</CollectionListLink>
        </Swiper>
      </StyledSwiper>
    </CollectionListContainer>
  )
}

const CollectionListContainer = styled.div`
  position: relative;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`

const StyledSwiper = styled.ul`
  position: relative;
  padding: 4vw;
  overflow: hidden;

  height: ${(props) =>
    props.theme.headerHeight.desktop.replace('vw', '') * 2}vw;
  background-color: ${(props) => props.theme.colors.white};
  border-bottom: 1px solid ${(props) => props.theme.colors.mediumGrey};
  z-index: 3;
  padding: 0 ${(props) => props.theme.space.marginMobile * 1.5}vw;

  .swiper-container {
    height: 100%;
    overflow: visible;
  }

  .swiper-container-horizontal > .swiper-scrollbar {
    display: none;
  }

  .swiper-wrapper {
    white-space: nowrap;
  }

  .swiper-container-horizontal > .swiper-scrollbar {
    display: none;
  }
`

const Slide = styled.li`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content !important;

  &:first-child {
    /* padding-left: ${(props) => props.theme.space.marginMobile * 1.5}vw; */
  }

  &:last-child {
    /* padding-right: ${(props) => props.theme.space.marginMobile * 1.5}vw; */
  }

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    & + li {
      padding: 0 0 0 ${(props) => props.theme.space.marginDesktop * 4}rem;
    }
  }
`

const CollectionListLink = styled(SiteLink)`
  font-family: ${(props) => props.theme.fontFamily.normal};
  font-size: ${(props) => props.theme.fontSize.m35};
  ${(props) =>
    props.selected
      ? `
    background: transparent linear-gradient(90deg, ${props.theme.colors.black}, ${props.theme.colors.black}) no-repeat 0 100%;
    background-size: 100% 1px;`
      : ''}
  letter-spacing: 0.05em;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d15};
    line-height: 1.2;
  }
`

export default CollectionSwitcher
